import type { BillingUsage } from '../api/planApi';

export const STORAGE_LIMIT_REACHED_MESSAGE =
  'Storage limit reached. Remove files or upgrade your plan before using this feature.';

export const isStorageLimitReached = (usage: BillingUsage): boolean => {
  const storageUsedBytes = Number(usage?.storageUsedBytes);
  const storageLimitBytes = Number(usage?.storageLimitBytes);

  if (!Number.isFinite(storageUsedBytes) || !Number.isFinite(storageLimitBytes) || storageLimitBytes <= 0) {
    return false;
  }

  return storageUsedBytes >= storageLimitBytes;
};
